import "./DataMapping.scss";
import {Droppable} from "@hello-pangea/dnd";
import React from "react";
import {MappingTableItem} from "./MappingTableItem";
import type {ClientArea, MithraArea} from "./MappingTableTypes";


type Props = {
    droppableId: string
    className: string
    clientItems: ClientArea
    mithraItems: MithraArea
}

// This method is needed for rendering clones of draggables
// This method define the behavior of the dragged object
const getRenderItem = (items) => (provided, snapshot, rubric) => {
    const item = items[rubric.source.index];
    return (
        <>
            <div
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={provided.innerRef}
                style={provided.draggableProps.style}
                className={snapshot.isDragging ? "data-item-dragging" : ""}
            >
                <div className="item-name">{item.column_letter}: {item.name}</div>
                {/* This is commented since the example might need to change when it will be parsed in the mithra column */}
                {/* <div className="item-example">{item.example}</div> */}
            </div>
        </>
    );
};

export const MappingClientColumn: React.FC<Props> = ({droppableId, className, clientItems, mithraItems}) => {
    const assignedItems = new Set(mithraItems.flatMap(m => m.items).map(i => i.name));
    return (
        <Droppable
            renderClone={getRenderItem(clientItems)}
            droppableId={droppableId}
            isDropDisabled={true}
        >
            {(provided, snapshot) => (
                <div ref={provided.innerRef} className={className}>
                    {clientItems.map((item, index) => {
                        const shouldRenderClone = item.id === snapshot.draggingFromThisWith;
                        const isMapped = assignedItems.has(item.name);
                        return (
                            <React.Fragment key={item.id}>
                                {shouldRenderClone ? (
                                    //this is the element that will appear in place of the original when drag starts
                                    <MappingTableItem isClone={true} example={item.example} name={item.name}
                                                      index={index}
                                                      id={item.id}
                                                      parentList={droppableId + 'clone'}
                                                      column_letter={item.column_letter}
                                                      isMapped={isMapped}></MappingTableItem>

                                ) : (
                                    <MappingTableItem name={item.name} example={item.example} index={index} id={item.id}
                                                      parentList={droppableId}
                                                      column_letter={item.column_letter}
                                                      isMapped={isMapped}></MappingTableItem>
                                )}
                            </React.Fragment>
                        );
                    })}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    )
}
